import { useNavigate } from 'react-router-dom';
import type { ReportSummary } from '@/types/coach';
import { routes } from '@/lib/routes';

interface Props {
  clientId: string;
  report: ReportSummary;
}

const DATE_FMT = new Intl.DateTimeFormat('de-DE', {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
});

export function ReportCard({ clientId, report }: Props) {
  const navigate = useNavigate();
  const title = report.title || 'Coaching-Bericht';
  return (
    <button
      type="button"
      onClick={() => navigate(routes.coach.report(clientId, report.id))}
      className="block w-full rounded-md border border-border bg-card px-4 py-3 text-left transition-colors hover:border-foreground/40"
    >
      <div className="text-[10px] font-medium uppercase tracking-wider text-muted-foreground">
        {DATE_FMT.format(new Date(report.reportDate))}
      </div>
      <div className="mt-0.5 text-sm font-semibold">{title}</div>
    </button>
  );
}
